export default {"src":"__ASTRO_ASSET_IMAGE__CagWr4DS__","width":1332,"height":1059,"format":"png"}